import React from 'react';
import { OverlayComponent } from 'app/components';
import { hasTranslationsValid } from 'app/components/translation/has-translations-valid';
import { validateImportSet } from '../utils/validate-import-set';
import { ImportSetContainerProps } from '../types';
import { ImportSetStickyHeader } from './import-set-sticky-header';

export const ImportSetContainer: React.FC<ImportSetContainerProps> = ({
  actionType, formState, mainLanguage, translation, children,
  switchTranslationsToggle, saveImportSet, duplicateImportSet,
  deleteImportSet, updateValidation, displayError
}) => {

  const { importSetItem, fetching, saving, deleting, languageOptions, validation } = formState;

  const onSave = () => {
    const formValidation = validateImportSet(actionType, importSetItem, languageOptions, translation);

    updateValidation({ ...validation, ...formValidation });

    if (Object.keys(formValidation).length > 0) {
      !hasTranslationsValid(formValidation.language, mainLanguage) && switchTranslationsToggle(true);
      displayError(translation.import_set_validation_error);
      return;
    }

    saveImportSet(importSetItem);
  };

  const importSetName = importSetItem.language
    ?.find(languageItem => languageItem.value === mainLanguage)
    ?.description;

  return <>
    <OverlayComponent
      displayOverlay={saving || deleting}
      overlayText={saving
        ? translation.saving_import_set
        : translation.deleting_import_set} />
    <ImportSetStickyHeader
      actionType={actionType}
      importSetItem={importSetItem}
      name={importSetName}
      fetching={fetching}
      displayError={displayError}
      onSave={onSave}
      onDuplicate={duplicateImportSet}
      onDelete={deleteImportSet}
      translation={translation} />
    {children}
  </>;
};
